import React, { useEffect, useState } from 'react';

import Button from '@components/Button';
import StyledModal from '@components/StyledModal';
import Typography from '@components/Typography';

export type ButtonType = 'primary' | 'destructive';

interface ErrorModalProps {
    errorText: string | undefined;
    showLoginError: boolean;
    onClick: () => void;
    buttonText?: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
    errorText,
    onClick,
    showLoginError,
    buttonText
}) => {
    const [actionLabel, setActionLabel] = useState('');

    useEffect(() => {
        if (buttonText) {
            setActionLabel(buttonText);
            return;
        }
        if (showLoginError) {
            setActionLabel('Login');
            return;
        }
        setActionLabel('Go Back');
    }, [showLoginError, buttonText]);

    return (
        <StyledModal open={!!errorText} style={{ padding: 24 }}>
            <Typography variant={'t6'} style={{ marginTop: 16 }}>
                Uh-oh! Something went wrong...
            </Typography>
            <Typography
                variant={'p5'}
                color="error"
                style={{
                    marginTop: 24,
                    textAlign: 'center',
                    marginBottom: 24
                }}
            >
                {errorText}
            </Typography>
            <Button
                variant={showLoginError ? 'primary.medium' : 'destructive.medium'}
                onPress={onClick}
            >
                {actionLabel}
            </Button>
        </StyledModal>
    );
};

export default ErrorModal;
